import { gql } from '@apollo/client'

export const EXPORT_PRODUCT_QUERY = gql`
  query TaxonomyGPCBricks(
    $first: Int
    $after: String
    $where: TaxonomyGPCBrickGraphQLFilterInput
    $order: [TaxonomyGPCBrickGraphQLSortInput!]
  ) {
    taxonomyGPCBricks(first: $first, after: $after, where: $where, order: $order) {
      nodes {
        id
        code
        brickName
        state
        segmentCode
        segmentName
        segmentDefinition
        familyCode
        familyName
        familyDefinition
        classCode
        className
        classDefinition
        definitionExcludes
        definitionIncludes
        transportCondition
        mainAttributeName
        verificationComments
        verifiedByName
        verifiedByEmail
        isVerified
        verifiedOn
        lastPublishedDate
        lastUpdatedName
        updated
        researcherName
        researcherEmail
        created
        userEmail
        mainAttributeId
        approvedForRelease
        allowRecipeGeneration
        minCarbonAllowed
        maxCarbonAllowed
        classId
        storageFoodCategory
        storageDurationInHours
        secondaryDataReferenceSourceType
        referenceAuthorName
        referenceLink
        storageReferenceLink
        referencesSamplingYear
        referenceDataPublicationYear
        referenceSourcingCountry
        dataQualityComment
        retailTransportCondition
        retailStorageFoodCategory
        retailStorageDurationInHours
        homeTransportCondition
        homeStorageFoodCategory
        homeStorageDurationInHours
        regionalDistributionTransportCondition
        regionalDistributionStorageFoodCategory
        regionalDistributionStorageDurationInHours
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
